<template>
  <div class="grid grid-cols-2 gap-3 w-full mt-10" :class="wrapperClass">
    <div
      v-for="(item, i) in items"
      :key="i"
      class="bg-white/5 border border-white/5 rounded-2xl p-3 text-center hover:bg-white/10 transition-colors cursor-default"
      :class="itemClass"
    >
      <i v-if="item.iconClass" :class="[item.iconClass, iconColorClass]" class="text-lg mb-1 block"></i>
      <p class="text-sm font-bold text-white">{{ item.value }}</p>
      <p class="text-[9px] text-white/30 uppercase tracking-wider font-bold">{{ item.label }}</p>
    </div>
  </div>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    default: () => []
  },
  iconColorClass: { type: String, default: 'text-white/40' },
  itemClass: { type: String, default: '' },
  wrapperClass: { type: String, default: '' }
});
</script>
